<template>
  <div class="main">
    <app-header v-if="isWaiterLogin" />
    <div class="login_container d-flex" id="login">
      <!-- Login Form (shown by default) -->
      <div v-if="!showBranchSelection" class="login_form d-flex flex-column justify-content-center align-items-center">
        <!-- Logo -->
        <div class="login_logo">
          <img class="logo_icon" src="../assets/LOGO _ HOME.png" alt="">
        </div>

        <!-- Login Title -->
        <div class="login_txt mt-2">
          <span>Login</span>
        </div>

        <!-- Username Input with Keypad -->
        <div class="login_username d-flex flex-row mt-4">
          <input 
            class="p-2" 
            type="text" 
            placeholder="Username" 
            v-model="form.username" 
            required
            ref="usernameInput"
            @keyup.enter="handleLogin"
          >
          <div class="key_button p-2 ml-2">
            <img src="../assets/Vector.png" alt=""  @click="openKeypad('usernameInput')">
          </div>
        </div>

        <!-- Password Input with Keypad -->
        <div class="login_password d-flex flex-row mt-4">
          <input 
            class="p-2" 
            type="password" 
            placeholder="Password" 
            v-model="form.password" 
            required
            ref="passwordInput"
            @keyup.enter="handleLogin"
          >
          <div class="key_button p-2 ml-2" @click="openKeypad('passwordInput')">
            <img src="../assets/Vector.png" alt="">
          </div>
        </div>

        <!-- Login Button -->
        <div class="login_button d-flex flex-row mt-4">
          <!-- <button class="log_button mx-auto" @click="handleLogin">LOGIN</button> -->
                     <button class="log_button mx-auto" @click="handleLogin">LOGIN</button>

        </div>
      </div>

      <!-- Branch Selection (shown after login if multiple branches exist) -->
      <div v-else class="branch_selection d-flex flex-column justify-content-center align-items-center">
        <div class="login_logo">
          <img class="logo_icon" src="../assets/LOGO _ HOME.png" alt="">
        </div>

        <h2 class="mt-3 mb-4">Select Branch</h2>

        <div class="branch_options">
          <div 
            v-for="branch in branches" 
            :key="branch.id" 
            class="branch_option"
            @click="selectBranch(branch)"
          >
            <img src="../assets/branch.svg" alt="Branch" class="branch_icon">
            <span class="branch_name">{{ branch.name }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Keypad Modal -->
    <Keypad 
    ref="keypad"
    :target-input="$refs[inputRef]"
    @cancel="closeKeypad"
/>
  </div>
</template>

<script>
import { BASE_API_URL } from '@/config'; 
import Keypad from './keypad_popup_component.vue';
import { Modal } from 'bootstrap'; 
export default {
  components: {
    Keypad
  },
  data() {
    return {
      isWaiterLogin: false,
      showBranchSelection: false,
      branches: [],
      form: {
        username: '',
        password: ''
      },
      showKeypad: false,
      currentInput: null
    }
  },
  created() {
    this.isWaiterLogin = this.$route.path === '/loginwaiter';
  },
  mounted() {
      this.$nextTick(() => {
          const modalElement = this.$refs.keypad.$el;
          this.keypadModal = new Modal(modalElement);
      });
  },
  methods: {
    openKeypad(inputRef) {
          this.$refs.keypad.setTargetInput(this.$refs[inputRef]);
          this.keypadModal.show();
      },
      closeKeypad() {
    this.keypadModal.hide();
  
  this.removeBackdrop();
},
removeBackdrop() {
  const backdrops = document.querySelectorAll('.modal-backdrop');
  backdrops.forEach(backdrop => backdrop.remove());
  document.body.classList.remove('modal-open');
  document.body.style.paddingRight = '';
},
    updateInputValue(value) {
      if (this.currentInput) {
        this.currentInput.value = value;
        if (this.currentInput === this.$refs.usernameInput) {
          this.form.username = value;
        } else if (this.currentInput === this.$refs.passwordInput) {
          this.form.password = value;
        }
      }
    },
    async fetchAndStoreLanguages() {
  try {
    this.$root.isLoading = true; 
          this.loading = true;
    const token = localStorage.getItem('authToken');
    console.log("token".token);
    const response = await fetch(`${BASE_API_URL}/api/languages?appId=${localStorage.getItem('appId')}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      },
    });

    const data = await response.json();
    
    if (data.status && data.data) {
      // Extract only the needed fields
      const minimalLanguageData = data.data.map(lang => ({
        id: lang.id,
        shortName: lang.shortName,
        fullName: lang.fullName
      }));
      
      // Store only the essential language data
      localStorage.setItem('languages', JSON.stringify(minimalLanguageData));
    } else {
      console.error('Failed to fetch languages:', data.message);
    }
  } catch (error) {
    console.error('Error fetching languages:', error);
  }
  finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
},

   async handleLogin() {
    if (!this.form.username || !this.form.password) {
        this.$toast.error('Please fill in all fields.');
        return;
    }

    const payload = {
        name: this.form.username,
        password: this.form.password,
        isWaiterLogin: false,
    };
    if (this.isWaiterLogin) {
        payload.appId = 1;
        payload.isWaiterLogin = true;
    }

    try {
        this.$root.isLoading = true; 
        this.loading = true;
        const loginResponse = await fetch(`${BASE_API_URL}/api/auth/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify(payload),
        });

        if (!loginResponse.ok) {
            throw new Error('Login failed. Please check your credentials.');
        }

        const loginData = await loginResponse.json();
        this.userData = loginData.data;

        // Store user data
        if (this.isWaiterLogin) {
            localStorage.setItem('waiterId', this.userData.user.waiter.id);
            localStorage.setItem('waiterToken', this.userData.token);
            localStorage.setItem('isWaiterSuspended', this.userData.user.waiter.isSuspend ? '1' : '0');
            localStorage.setItem('WaiterBranchId', this.userData.user.waiter.branchId);
            
            if (this.userData.user.waiter.isSuspend == 1) {
                this.$toast.error('Your account is not activated');
                return;
            }
            
            // Set colors for waiter
            if (this.userData.user.current_app_colors) {
                const { background_color, font_color } = this.userData.user.current_app_colors;
                this.$globalAppSettings.backgroundColor = background_color;
                this.$globalAppSettings.fontColor = font_color;
                window.__globalAppSettings = {
                    ...window.__globalAppSettings,
                    backgroundColor: background_color,
                    fontColor: font_color
                };
                localStorage.setItem('appBackgroundColor', background_color);
                localStorage.setItem('appFontColor', font_color);
            }
        } else {
            localStorage.setItem('userPermissions', JSON.stringify(this.userData.user.permissions));
            localStorage.setItem('authToken', this.userData.token);
            localStorage.setItem('lang', this.userData.user.langId);
            localStorage.setItem('userId', this.userData.user.id);
            localStorage.setItem('username', this.userData.user.name);
            
            const expiresInHours = 2; 
            const expiryTimestamp = Date.now() + (expiresInHours * 60 * 60 * 1000);
            localStorage.setItem('tokenExpiry', expiryTimestamp);

            const apps = this.userData.user.apps; 
            const appId = Object.keys(apps)[0];
            localStorage.setItem('appId', appId);

            // Set both background and font colors
            if (this.userData.user.app_colors && this.userData.user.app_colors[appId]) {
                const { background_color, font_color } = this.userData.user.app_colors[appId];
                this.$globalAppSettings.backgroundColor = background_color;
                this.$globalAppSettings.fontColor = font_color;
                window.__globalAppSettings = {
                    ...window.__globalAppSettings,
                    backgroundColor: background_color,
                    fontColor: font_color
                };
                localStorage.setItem('appBackgroundColor', background_color);
                localStorage.setItem('appFontColor', font_color);
            }
        }

        const appBranches = this.userData.user.apps['1'];
        
        if (!this.isWaiterLogin) {
            await this.fetchAndStoreLanguages();
        }

        if (appBranches) {
            if (appBranches.length === 1) {
                await this.storeBranchDetails(appBranches[0]);
                this.redirectAfterLogin();
            } else {
                await this.fetchBranchDetails(appBranches);
                this.showBranchSelection = true;
            }
        } else {
            this.redirectAfterLogin();  
        }
    } catch (error) {
        console.error('Login Error:', error);
        this.$toast.error(error.message || 'An error occurred. Please try again.');
    } finally {
        this.$root.isLoading = false;
        this.loading = false;
    }
},

    async storeBranchDetails(branchId) {
  try {
    this.$root.isLoading = true; 
          this.loading = true;
    const token = localStorage.getItem('authToken');
const response = await fetch(`${BASE_API_URL}/api/branches/${branchId}/name-id?appId=${localStorage.getItem('appId')}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      },
    });

    let branchName = `Branch ${branchId}`;
    let appId = 1;
    
    if (response.ok) {
      console.log(response);
      const branchData = await response.json();
      branchName = branchData.data.name || branchName;
      appId = 1; 
    }

    // Store branch details in localStorage
    localStorage.setItem('branchId', branchId);
    localStorage.setItem('branchName', branchName);
    if (appId) {
      localStorage.setItem('appId', appId);
    }

  } catch (error) {
    console.error('Error fetching branch details:', error);
    localStorage.setItem('branchId', branchId);
    localStorage.setItem('branchName', `Branch ${branchId}`);
  }
  finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
},

    async fetchBranchDetails(branchIds) {
  try {
    this.$root.isLoading = true; 
          this.loading = true;
    const token = localStorage.getItem('authToken');
    const branches = [];

    for (const branchId of branchIds) {
     const response = await fetch(`${BASE_API_URL}/api/branches/${branchId}/name-id?appId=${localStorage.getItem('appId')}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
        },
      });

      if (response.ok) {
        const branchData = await response.json();
        branches.push({
          id: branchData.data.id,
          name: branchData.data.name || `Branch ${branchData.data.id}`,
          appId: 1
        });
      } else {
        console.error(`Failed to fetch branch ${branchId}:`, response.statusText);
        branches.push({
          id: branchId,
          name: `Branch ${branchId}`,
          appId: null
        });
      }
    }

    this.branches = branches;
  } catch (error) {
    console.error('Error fetching branches:', error);
    this.branches = branchIds.map(id => ({ 
      id, 
      name: `Branch ${id}`,
      appId: null 
    }));
  }
  finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
},

selectBranch(branch) {
  localStorage.setItem('branchId', branch.id);
  localStorage.setItem('branchName', branch.name);
  
  if (branch.appId) {
    localStorage.setItem('appId', branch.appId);
  }
  
  this.redirectAfterLogin();
},

    redirectAfterLogin() {
      if (this.isWaiterLogin) {
        this.$router.push('/tables');
      } else {
        this.$router.push('/home');
      }
    }
  },
};
</script>

<style scoped>
.main{
  margin-top: -2.87rem;
}
.login_container {
  font-family: 'Roboto', sans-serif;
  background-color: #f8f9fa;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}

.login_form, .branch_selection {
  background-color: #ffffff;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  background-color: #303030;
}

.login_logo img {
  width: 100px;
  height: auto;
}

.login_txt span {
  font-size: 1.5rem;
  font-weight: 500;
  color: #333;
}

.login_username,
.login_password {
  width: 100%;
}

.login_username input,
.login_password input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid;
  border-radius: 5px;
  font-size: 1rem;
}

.key_button {
  background-color: #f8f9fa;
  border: 1px solid;
  border-radius: 5px;
  cursor: pointer;
}

.key_button img {
  width: 20px;
  height: auto;
}
.key_button {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
  border-radius: 4px;
}

.key_button:hover {
  background: #e0e0e0;
}
.log_button {
  background-color: #298b61;
  color: #fff;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 5px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.log_button:hover {
  background-color: #1f6f4a;
}

/* Branch Selection Styles */
.branch_options {
  width: 100%;
  margin-top: 1rem;
}

.branch_option {
  display: flex;
  align-items: center;
  padding: 1rem;
  margin-bottom: 0.5rem;
  border: 1px solid;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.branch_option:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.branch_icon {
  width: 30px;
  height: 30px;
  margin-right: 1rem;
}

.branch_name {
  font-size: 1rem;
  font-weight: 500;
}
</style>